
import Router from './components/Router/Router';

import './App.css';







function App() {
  return (
    <div className="App">
    <Router/>
    </div>
  );
}

export default App;
